import { Component } from '@angular/core';

@Component({
  selector: 'managers-agreements-holders-modal',
  templateUrl: './managers-agreements-holders-modal.component.html',
  styleUrls: ['./managers-agreements-holders-modal.component.scss']
})
export class ManagersAgreementsHoldersModalComponent {}
